import { Component, Prop, Vue } from 'vue-property-decorator';
import UpSaleIconComponent from "Components/Ecom/Product/UpSale/UpSaleComponent";

@Component({
    components: {
        UpSaleIconComponent
    }
})
export default class CartComponent extends Vue {

    mounted() {}

    onQuantityUpSaleEmit(key: string, value: number) {
        const elm = this.$refs["unitquantity" + key] as HTMLInputElement;

        let current = Number.parseInt(elm.value);
        if (isNaN(current))
            return;

        elm.value = value + "";
        const norriq = (<any>window).NORRIQ as any;
        if (norriq == null) return;

        const autoAdd = norriq.autoadd as any;
        if (autoAdd == null) return;
        autoAdd.triggerQuantity(key, value);
    }

    onChange(counter: string, event: Event) {
        const elm = this.$refs['unitquantity' + counter] as HTMLInputElement;

        const obj = {
            key: counter,
            quantity: elm.value
        };
        this.$emit('quanity-changed', obj);
    }
}
Vue.component('cart', CartComponent);